<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.messageConfig.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/integrationMessageConfig"><span>{{$t('tlt.messageConfig')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/integrationMessageConfig/edit"><span>{{$t('tlt.messageConfig.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <mmf-button type="cancel" show-name v-bind:class="'btn btn-outline-secondary mr-1'" v-on:click="MMFbackToList('integrationMessageConfig')"></mmf-button>
                    <mmf-button type="save" show-name v-bind:class="'btn btn-primary'" v-on:click="validateForm"></mmf-button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <div class="card">
                <div class="card-body">
                <mmf-entity-form entity="integrationMessageConfig">
                </mmf-entity-form>
                </div>
            </div>
            <div class="card my-1">
                <div class="card-body">
                    <mmf-edit-table form="integrationMessageConfigEditForm" entity="integrationMessageConfig" attributeEntity='messageDataConversion' attributeKey='messageDataConversions'>
                    </mmf-edit-table>
                </div>
            </div>
            <form id="integrationMessageConfigEditForm"></form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapState, mapActions } from "vuex";
import {fields}  from "@/model/adm/IntegrationMessageConfig";
import MmfEditTable  from "@/components/MmfEditTable";
import MmfButton  from "@/components/MmfButton";
import MmfEntityForm  from "@/components/MmfEntityForm";

const { mapFields } = createHelpers({
  getterType: 'integrationMessageConfig/getField',
  mutationType: 'integrationMessageConfig/updateField',
});
export default {
  mounted(){
    this.$store.dispatch('integrationMessageConfig/loadMessageType');
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
        entity: state => state.integrationMessageConfig.entity,
        messageType: state => state.integrationMessageConfig.messageType
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"]),
    validateForm () {
        var mdcList = this.$store.state["integrationMessageConfig"].entity["messageDataConversions"]
        if (mdcList !== []) {
            for (var i=0; i < mdcList.length; i++){
                delete mdcList[i]["rowState"]
            }
        }
        this.$validator.validateAll().then(isValid => {
            if( isValid ){
                this.$store.dispatch('base/MMFSave', 'integrationMessageConfig');
            }
        });
    }
  },
  components: {
    MmfEditTable, MmfButton, MmfEntityForm
  }
};
</script>